module.exports = __webpack_public_path__ + "img/22.cb030fd3.png";